import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  signal,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { AdsenseService } from '../../../../core/services/adsense.service';

import { PlatformService } from '../../../../core/services/platform.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from '../../../../../environments/environment';
import { IFrameAutoWidthHeightDirective } from '../../../directives/iframe-auto-width-height.directive';
import { VisitorService } from '../../../../core/services/visitor.service';
import { DocumentService } from '../../../../core/services/document.service';
@Component({
  selector: 'app-ad, [app-ad]',
  templateUrl: './rectangle.component.html',
  styleUrl: './rectangle.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [],
})
export class ADRectangleComponent {
  @Input('ad-width') width: 300 | 970 | 728 | undefined;
  @Input('ad-height') height: 250 | 90 | undefined;

  @ViewChild('ins')
  set ins(elm: ElementRef) {
    if (!this.isRendered && elm?.nativeElement) {
      this.isRendered = true;
      this.render(elm.nativeElement);
    }
  }
  @ViewChild('parent') parent!: ElementRef<HTMLDivElement>;
  adId = signal<number>(0);
  // @ViewChild('ins')
  // set ins(elm: ElementRef) {
  //   this.callAdsens(elm);
  // }
  isImplemented = false;
  url: SafeUrl = '';
  _width = '';
  _height = '';
  isRendered = false;
  isAutoSize = signal(false);
  adsnseID = 'ca-pub-1084596637776747';
  constructor(
    private documentService: DocumentService,
    public pt: PlatformService,
    public adsenseService: AdsenseService,
    //  private domSanitizer: DomSanitizer,
    public visitorService: VisitorService,
  ) { }
  ngOnChanges() {
    if (!environment.production || this.pt.isServer) return;

    if (this.pt.isMobile) {
      this.width = undefined;
      this.height = undefined;
      this._width = '100%';
      this._height = '205px';
      this.isAutoSize.set(true);
    } else if (!this.width && !this.height) {
      this._width = '100%';
      this.isAutoSize.set(true);
    } else {
      if (this.width) {
        this._width = this.width + 'px';
      } else {
        this._width = '100%';
      }
      if (this.height) {
        this._height = this.height + 'px';
      }
    }
    console.log('this._width', this._width);
    console.log('this._height', this._height);

    this.adId.set(this.adsenseService.adUnit);
  }

  render(ins: HTMLDivElement) {
    setTimeout(() => {
      this.adsenseService.push(
        ins,
        this.parent.nativeElement,
        this._width,
        this._height,
      );
    }, 0);
  }
}
